var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrdersArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6411 0.231167C11.4369 0.0624024 11.1744 -0.0188489 10.9106 0.00511375C10.6468 0.0290764 10.4031 0.156311 10.2327 0.3591L6.00013 5.43751L1.76746 0.359184C1.59755 0.155599 1.35372 0.0278505 1.08962 0.00404118C0.825512 -0.0197681 0.562768 0.062312 0.359184 0.232225C0.155599 0.402138 0.0278505 0.645966 0.00404118 0.910068C-0.0197681 1.17417 0.0623122 1.43691 0.232225 1.6405L5.23251 7.64076C5.32631 7.75325 5.44369 7.84375 5.57634 7.90585C5.70898 7.96795 5.85366 8.00014 6.00013 8.00014C6.14659 8.00014 6.29127 7.96795 6.42391 7.90585C6.55656 7.84375 6.67394 7.75325 6.76774 7.64076L11.768 1.64042C11.9379 1.43662 12.0199 1.17375 11.9961 0.909527C11.9723 0.645301 11.8446 0.401322 11.6411 0.231167Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersArrow);
export default __webpack_public_path__ + "static/media/OrdersArrow.c0d5724adaabcbaa3d2e4e7a1f7ef335.svg";
export { ForwardRef as ReactComponent };